import { SET_CURRENT_PROPERTY, SET_CURRENT_ADDRESS, SET_CURRENT_OWNERTYPE } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export interface currentPropertyState {
    currentProperty?: string;
    currentAddress?: string;
    currentOwnerType?: string;
}

// Define an initial state value for the app
const initialState: currentPropertyState = {}
  
function currentPropertyReducer(state = initialState, action: AppAction) {

    const { value } = action;

    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return {
                ...state,
                currentProperty: value
            }
        case SET_CURRENT_ADDRESS:
            return {
                ...state,
                currentAddress: value
            }
        case SET_CURRENT_OWNERTYPE:
            return {
                ...state,
                currentOwnerType: value
            }
        default:
            return state;
    }
}

export default currentPropertyReducer;